import React, { useState, useContext } from "react";
import "./Screens.scss";
import { AppContext } from "../../Context/AppContext";
import axios from "axios";
// Material UI
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
// import years from "../../LocalData/Years.json";
// Custom Plugins
import { customCloneDeep, getYears } from "../../Plugins/HelperFunctions"


const Screen1 = () => {
  // Variables
  const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002" : "https://secure-temple-73063.herokuapp.com") || "https://carcalculator.herokuapp.com";

  //  States
  const {
    screensData,
    setScreensData,
    setActiveScreen,
    setShowSnackbar,
    setSnackbarMessage,
    setShowSpinner,
    setActiveFocus,
  } = useContext(AppContext);
  const [screen1, setScreen1] = useState(screensData.screen1);
  const [yearFilter, setYearFilter] = useState(getYears(1971));
  const [yearFilterClone, setYearFilterClone] = useState(getYears(1971));
  const [yearValue, setYear] = useState('');

  // Change Handler
  const handleChange = (e, name_) => {
    let { value } = e.target;
    let name = name_
    let errorName = `${name}Error`;
    if (name === "year") {
      setYear(value)
    }
    /* 1- To Ensure Value Is Set Immediately */
    if (value === "" || value === undefined) {
      setScreen1({
        ...screen1,
        [name]: value,
        [errorName]: true,
      });
      return;
    } else {
      setScreen1({
        ...screen1,
        [name]: value,
        [errorName]: false,
      });
    }


    /* 2- To Fetch Data Based On Values */
    if (name === "year") {
      setShowSpinner(true);
      axios.get(`${baseUrl}/makes/${value}`).then((res) => {
        setScreen1({
          ...screen1,
          [name]: value,
          [errorName]: false,
          makes: res.data.data,
          make: '',
          model: '',
        });
        setShowSpinner(false);
      });
    } else if (name === "make") {
      setShowSpinner(true);
      axios
        .post(`${baseUrl}/models`, { year: screen1.year, make: value })
        .then((res) => {
          setScreen1({
            ...screen1,
            [name]: value,
            [errorName]: false,
            models: res.data.data,
            model: '',
          });
          setShowSpinner(false);
        });
    } else if (name === "vin") {
      if (value.length === 17) {
        sessionStorage.setItem('value', 1)
        setShowSpinner(true);
        axios.get(`${baseUrl}/vin/${value}`).then((res) => {
          setScreen1({
            ...screen1,
            [name]: value,
            yearError: false,
            makeError: false,
            modelError: false,
            [errorName]: false,
            vinDecodedDetails: res.data.data,
          });
          setShowSpinner(false);
        });
      } else {
        setScreen1({
          ...screen1,
          [name]: value,
          [errorName]: true,
        });
      }
    }
  };

  // year filters
  const setYearValue = (year) => {
    setYear(year)
    if (year.length > 0) {
      const data = yearFilter.filter((item) => {
        let year_ = item.toString();
        if (year_.includes(year)) {
          return parseInt(year_)
        }
      })
      setYearFilterClone(data);
    } else {
      setYearFilterClone(yearFilter);
    }
  }

  // Form Validator
  const formValidator = () => {
    let inputs = ["year", "make", "model", "vin"];
    let errors = {
      yearError: false,
      makeError: false,
      modelError: false,
      vinError: false,
    };

    inputs.forEach((input) => {
      const errorName = `${input}Error`;
      if (screen1[input] === "" || screen1[input] === undefined) {
        errors[errorName] = true;
      }
    });

    setScreen1({
      ...screen1,
      ...errors,
    });

    //  For Only This Screen
    if (screen1.year || screen1.make || screen1.model) {
      setScreen1({
        ...screen1,
        vinError: false,
      });
    } else if (screen1.vin && !screen1.vinError) {
      setScreen1({
        ...screen1,
        yearError: false,
        makeError: false,
        modelError: false,
      });
    }
  };


  // Submit Handler
  const submitForm = (e) => {
    e.preventDefault();

    
      // formValidator();

      let clonedScreensData = customCloneDeep(screensData);

      if (!(Object.entries(screen1.vinDecodedDetails).length === 0)) {
        const vinDecodedDetails = screen1.vinDecodedDetails;

        clonedScreensData.screen1 = {
          ...screen1,
          year: vinDecodedDetails.year,
          // make: vinDecodedDetails.make,
          // model: vinDecodedDetails.model,
          yearError: false,
          makeError: false,
          modelError: false,
        };
        clonedScreensData.screen2 = {
          trim: vinDecodedDetails.trim,
          trimError: false,
          trims: [],
        };

        setScreensData(clonedScreensData);
        setActiveScreen((prevactiveScreen) => prevactiveScreen + 2);
      } else {
        clonedScreensData.screen1 = screen1;
        setScreensData(clonedScreensData);
        setActiveScreen((prevactiveScreen) => prevactiveScreen + 2);
      }
  };

  return (
    <div className="screen">
      <form onSubmit={submitForm} autoComplete="off">
        <Box className="screen__wrapper">
          <FormControl fullWidth error={screen1.yearError}>
            <InputLabel id="year-select-label">Year</InputLabel>
            <Select
                labelId="year-select-label"
                label="Year"
                name="year"
                value={screen1.year}
                onFocus={() => setActiveFocus("year")}
                onChange={(e)=>handleChange(e,"year")}
            >
              {getYears(1971).map((year, i) => (
                  <MenuItem value={year} key={i}>
                    {year}
                  </MenuItem>
              ))}
            </Select>
            {screen1.yearError && <FormHelperText>Required</FormHelperText>}
          </FormControl>
          {/*Year List*/}

          <FormControl fullWidth error={screen1.makeError}>
            <InputLabel id="make-select-label">Make</InputLabel>
            <Select
                labelId="make-select-label"
                label="Make"
                name="make"
                value={screen1.make}
                onFocus={() => setActiveFocus("make")}
                onChange={(e)=>handleChange(e,"make")}
                  disabled={!screen1.makes.length}
            >
              {screen1.makes
                  .sort((a, b) => a.localeCompare(b))
                  .map((make, i) => (
                      <MenuItem value={make} key={i}>
                        {make}
                      </MenuItem>
                  ))}
            </Select>
            {screen1.makeError && <FormHelperText>Required</FormHelperText>}
          </FormControl>

          <FormControl fullWidth error={screen1.modelError}>
            <InputLabel id="model-select-label">Model</InputLabel>
            <Select
                labelId="model-select-label"
                label="Model"
                name="model"
                value={screen1.model}
                onFocus={() => setActiveFocus("model")}
                onChange={(e)=>handleChange(e,"model")}
                  disabled={!screen1.models.length}
            >
              {screen1.models && screen1.models.map((model, i) => (
                  <MenuItem value={model} key={i}>
                    {model}
                  </MenuItem>
              ))}
            </Select>
            {screen1.modelError && <FormHelperText>Required</FormHelperText>}
          </FormControl>

          <Divider className="divider">
            <Typography variant="h6" component="h6" align="center">
              OR
            </Typography>
          </Divider>

          <FormControl fullWidth>
            <TextField
              label="Vin"
              variant="outlined"
              name="vin"
              value={screen1.vin}
              error={screen1.vinError}
              helperText={`${screen1.vinError
                ? "Invalid VIN or VIN not found. Note: VIN must be 17 characters long."
                : ""
                }`}
              onFocus={() => setActiveFocus("vin")}
              onChange={(e) => handleChange(e, "vin")}
            />
          </FormControl>


          {/*Get Quote*/}
          <Button variant="contained" color="primary" type="submit">
            Next
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default Screen1;
